<template>
  <div class="container-fluid">
    <div class="row">
      <main id="main" class="site-main main-content">
        <article
          id="post-2252"
          class="post-2252 page type-page status-publish hentry"
        >
          <div class="entry-content">
            <div class="hc-contact">
              <div class="container">
                <div class="row tick-cont">
                  <div class="col-md-12 submit-form">
                    <div class="form-title">
                      <h1
                        class="logo"
                        style="margin: 0 auto; text-align: center"
                      >
                        <a
                          href="https://www.clearmeout.com/"
                          style="
                            display: block;
                            width: fit-content;
                            margin: auto;
                          "
                        >
                          <img
                            class="img-responsive"
                            src="/static/assets/images/logo.png"
                            alt="ClearMeOut"
                          />
                        </a>
                      </h1>
                      <h3 style="margin: 10px auto; text-align: center">
                        Business Service Request Form
                      </h3>
                      <p style="margin: 10px auto 50px; text-align: center">
                        Submit your information for obtaining the Business Service on Business Content Removal.
                      </p>
                    </div>

                    <form class="wpcf7-form" @submit.prevent="submit">
                      <div class="form-group">
                        <label for="exampleInputEmail1">Business Category*</label>
                        <span
                          class="wpcf7-form-control-wrap select-options"
                          style="display: block; width: 100%"
                          ><select
                            v-model="businessType"
                            name="businessType"
                            class="wpcf7-form-control wpcf7-select wpcf7-validates-as-required"
                            aria-required="true"
                            aria-invalid="false"
                            required
                            style="background: white; width: 100%"
                          >
                            <option value="Business">Business</option>
                            <option value="Celebrity">Celebrity/VIP</option>
                          </select></span
                        >
                      </div>
                      <div class="form-group">
                        <label for="exampleInputEmail1">Who I am*</label>
                        <span
                          class="wpcf7-form-control-wrap select-options"
                          style="display: block; width: 100%"
                          ><select
                            v-model="userType"
                            name="userType"
                            class="wpcf7-form-control wpcf7-select wpcf7-validates-as-required"
                            aria-required="true"
                            aria-invalid="false"
                            required
                            style="background: white; width: 100%"
                          >
                            <option value="MySelf">Myself</option>
                            <option value="Representer">Representer</option>
                            <option value="Guardian" v-if="businessType === 'Celebrity'">Guardian</option>
                          </select></span
                        >
                      </div>
                      <h3 v-if="businessType === 'Celebrity' && userType === 'Representer'" style="margin-bottom: 20px;">Representer Details</h3>
                      <h3 v-if="businessType === 'Celebrity' && userType === 'Guardian'" style="margin-bottom: 20px;">Guardian Details</h3>
                      <div class="form-group">
                        <label for="exampleInputEmail1">Full Name*</label>
                        <input
                          type="text"
                          class="form-control"
                          id=""
                          aria-describedby=""
                          placeholder="Enter Full Name"
                          required=""
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputEmail1">Date of Birth*</label>
                        <datetime
                          v-model="dateOfBirth"
                          type="date"
                          input-style="width: 100%;"
                          required=""
                        ></datetime>
                      </div>
                      <div class="form-group">
                        <label for="exampleInputEmail1">Gender*</label>
                        <span
                          class="wpcf7-form-control-wrap select-options"
                          style="display: block; width: 100%"
                          ><select
                            v-model="gender"
                            name="gender"
                            class="wpcf7-form-control wpcf7-select wpcf7-validates-as-required"
                            aria-required="true"
                            aria-invalid="false"
                            required=""
                            style="background: white; width: 100%"
                          >
                            <option value="N/A">N/A</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                          </select></span
                        >
                      </div>
                      <div class="form-group">
                        <label for="exampleInputEmail1">Email address*</label>
                        <input
                          type="email"
                          class="form-control"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                          placeholder="Enter email"
                          required=""
                        />
                        <button
                          type="button"
                          class="btn btn-primary"
                          style="margin: 10px 1px; display: block;border-radius: 10px;background:#6773DD;"
                        >
                          Verify
                        </button>
                      </div>
                      <div class="form-group">
                        <label for="exampleInputEmail1">Mobile Number*</label>
                        <div
                          style="
                            flex: 1 1 0%;
                            flex-direction: row;
                            justify-content: space-between;
                            display: flex;
                            border: 1px solid #c8cccf;
                            border-radius: 10px;
                          "
                        >
                          <vue-country-code
                            @onSelect="onSelect"
                            :preferredCountries="['lk', 'us', 'gb']"
                            style="border: 0"
                          >
                          </vue-country-code>
                          <input
                            class="form-control"
                            id="exampleInputEmail1"
                            aria-describedby="emailHelp"
                            placeholder="Enter mobile number"
                            required=""
                            type="tel"
                            style="max-width: 90%; border: 0"
                          />
                        </div>
                        <button
                          type="button"
                          class="btn btn-primary"
                          style="margin: 10px 1px; display: block;border-radius: 10px;background:#6773DD;"
                        >
                          Verify
                        </button>
                      </div>
                      <div class="form-group">
                        <label for="exampleInputPassword1"
                          >Address Line 1*</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          id="exampleInputAddressLine1"
                          placeholder="Enter Address Line 1"
                          required=""
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputPassword1"
                          >Address Line 2</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          id="exampleInputAddressLine2"
                          placeholder="Enter Address Line 2"
                          required=""
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputPassword1"
                          >State / Province</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          id="exampleInputState"
                          placeholder="Enter State / Province"
                          required=""
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputPassword1"
                          >Postal / Zip Code</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          id="exampleInputPostal"
                          placeholder="Enter Postal / Zip Code"
                          required=""
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputPassword1">City</label>
                        <input
                          type="text"
                          class="form-control"
                          id="exampleInputCity"
                          placeholder="Enter City"
                          required=""
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputPassword1">Country</label>
                        <div
                          style="
                            flex: 1 1 0%;
                            flex-direction: row;
                            justify-content: space-between;
                            display: flex;
                            border: 1px solid #c8cccf;
                            border-radius: 10px;
                          "
                        >
                          <vue-country-code
                            @onSelect="onSelectCountry"
                            :preferredCountries="['lk', 'us', 'gb']"
                            style="border: 0"
                          >
                          </vue-country-code>
                          <input
                            class="form-control"
                            id="exampleInputEmail1"
                            aria-describedby="emailHelp"
                            placeholder="Enter Country"
                            required=""
                            type="text"
                            readonly
                            style="max-width: 90%; border: 0"
                            v-model="country"
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="exampleInputPassword1"
                          >National Identity Card or Passport*<span class="tooltip" style="display: contents;">
                            <span class="tooltiptext"></span>
                            <span class="fa fa-question-circle"></span>
                          </span></label
                        >
                        <div v-bind:key="index" v-for="(item, index) in clientInputNIC" style="display: block; margin: 10px 0; position: relative;">
                          <input
                            type="file"
                            class="form-control"
                            v-on:change="onChangeClientInputNICDocs($event, index)"
                            name="inputNIC"
                            id="exampleInputNIC"
                            accept=".jpg,.png"
                            required=""
                          />
                          <button
                            type="button"
                            v-if="(clientInputNIC.length - 1) == index && (clientInputNIC.length) !== clientInputNICLimit"
                            style="position: absolute; top: calc((100% - 25px) / 2); right: -30px; height: 25px;"
                            v-on:click="onAddClientInputNIC"
                          >
                            +
                          </button>
                        </div>
                        <!-- <input
                          type="file"
                          class="form-control"
                          name="exampleInputIDPassportFront"
                          id="exampleInputIDPassportFront"
                          accept=".jpg,.png"
                          required=""
                        />
                        <input
                          type="file"
                          class="form-control"
                          name="exampleInputIDPassportBack"
                          id="exampleInputIDPassportBack"
                          accept=".jpg,.png"
                          required=""
                        /> -->
                      </div>
                      <div class="form-group" v-if="userType == 'Representer'">
                        <label for="exampleInputPassword1">Permission Letter*<span class="tooltip" style="display: contents;">
                            <span class="tooltiptext"></span>
                            <span class="fa fa-question-circle"></span>
                          </span></label>
                          <div v-bind:key="index" v-for="(item, index) in clientInputPermissionLetter" style="display: block; margin: 10px 0; position: relative;">
                            <input
                              type="file"
                              class="form-control"
                              v-on:change="onChangeClientInputNICDocs($event, index)"
                              name="inputNIC"
                              id="exampleInputNIC"
                              accept=".jpg,.png"
                              required=""
                            />
                            <button
                              type="button"
                              v-if="(clientInputPermissionLetter.length - 1) == index && (clientInputPermissionLetter.length) !== clientInputPermissionLetterLimit"
                              style="position: absolute; top: calc((100% - 25px) / 2); right: -30px; height: 25px;"
                              v-on:click="onAddClientInputPermissionLetter"
                            >
                              +
                            </button>
                          </div>
                        <!-- <input
                          type="file"
                          class="form-control"
                          id="exampleInputBillingProof"
                          accept=".jpg,.png"
                          required=""
                        /> -->
                      </div>
                      <div class="form-group">
                        <label for="exampleInputPassword1">Billing Proof*<span class="tooltip" style="display: contents;">
                            <span class="tooltiptext"></span>
                            <span class="fa fa-question-circle"></span>
                          </span></label>
                          <div v-bind:key="index" v-for="(item, index) in clientInputBillingProof" style="display: block; margin: 10px 0; position: relative;">
                            <input
                              type="file"
                              class="form-control"
                              v-on:change="onChangeClientInputNICDocs($event, index)"
                              name="inputNIC"
                              id="exampleInputNIC"
                              accept=".jpg,.png"
                              required=""
                            />
                            <button
                              type="button"
                              v-if="(clientInputBillingProof.length - 1) == index && (clientInputBillingProof.length) !== clientInputBillingProofLimit"
                              style="position: absolute; top: calc((100% - 25px) / 2); right: -30px; height: 25px;"
                              v-on:click="onAddClientInputBillingProof"
                            >
                              +
                            </button>
                          </div>
                        <!-- <input
                          type="file"
                          class="form-control"
                          id="exampleInputBillingProof"
                          accept=".jpg,.png"
                          required=""
                        /> -->
                      </div>
                      <div class="form-group">
                        <label for="exampleInputPassword1">Supporting Documents*<span class="tooltip" style="display: contents;">
                            <span class="tooltiptext"></span>
                            <span class="fa fa-question-circle"></span>
                          </span></label>
                        <!-- <input
                          type="file"
                          class="form-control"
                          id="exampleInputBillingProof"
                          accept=".jpg,.png"
                          required=""
                        /> -->
                         <div v-bind:key="index" v-for="(item, index) in clientInputSupportingDocs" style="display: block; margin: 10px 0; position: relative;">
                            <input
                              type="file"
                              class="form-control"
                              v-on:change="onChangeClientInputNICDocs($event, index)"
                              name="inputNIC"
                              id="exampleInputNIC"
                              accept=".jpg,.png"
                              required=""
                            />
                            <button
                              type="button"
                              v-if="(clientInputSupportingDocs.length - 1) == index && (clientInputSupportingDocs.length) !== clientInputSupportingDocsLimit"
                              style="position: absolute; top: calc((100% - 25px) / 2); right: -30px; height: 25px;"
                              v-on:click="onAddClientInputSupportingDocs"
                            >
                              +
                            </button>
                          </div>
                      </div>
                      <div class="form-group">
                        <label for="exampleInputPassword1">Signature*<span class="tooltip" style="display: contents;">
                            <span class="tooltiptext"></span>
                            <span class="fa fa-question-circle"></span>
                          </span></label>
                        <!-- <input
                          type="file"
                          class="form-control"
                          id="exampleInputSignature"
                          accept=".jpg,.png"
                          required=""
                        /> -->
                        <div v-bind:key="index" v-for="(item, index) in clientInputSign" style="display: block; margin: 10px 0; position: relative;">
                            <input
                              type="file"
                              class="form-control"
                              v-on:change="onChangeClientInputNICDocs($event, index)"
                              name="inputNIC"
                              id="exampleInputNIC"
                              accept=".jpg,.png"
                              required=""
                            />
                            <button
                              type="button"
                              v-if="(clientInputSign.length - 1) == index && (clientInputSign.length) !== clientInputSignLimit"
                              style="position: absolute; top: calc((100% - 25px) / 2); right: -30px; height: 25px;"
                              v-on:click="onAddClientInputSign"
                            >
                              +
                            </button>
                          </div>
                      </div>
                      <div class="form-group">
                        <label for="exampleInputPassword1">Password*</label>
                        <input
                          v-bind:type="userPasswordType"
                          class="form-control"
                          id="exampleInputPassword1"
                          placeholder="Enter Password"
                          required=""
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputPassword2"
                          >Re-Type Password*</label
                        >
                        <input
                          v-bind:type="userPasswordType"
                          class="form-control"
                          id="exampleInputPassword2"
                          placeholder="Re-Type Password"
                          required=""
                        />
                        <a v-if="!viewUserPassword" href="javascript:void(0)" style="display: block;margin: 10px 0px;" v-on:click="showPassword">Show Password</a>
                        <a v-if="viewUserPassword" href="javascript:void(0)" style="display: block;margin: 10px 0px;" v-on:click="hidePassword">Hide Password</a>
                      </div>
                      <h3 v-if="businessType === 'Business'" style="margin-bottom: 20px;">Company Details</h3>
                      <div v-if="businessType === 'Business'">
                        <div class="form-group">
                          <label for="exampleInputEmail1">Company Name*</label>
                          <input
                            type="text"
                            class="form-control"
                            id=""
                            aria-describedby=""
                            placeholder="Enter Full Name"
                            required=""
                          />
                        </div>
                        <div
                          class="form-group"
                          v-if="userType == 'Representer'"
                        >
                          <label for="exampleInputEmail1">Company Email*</label>
                          <input
                            type="email"
                            class="form-control"
                            id="exampleInputEmail1"
                            aria-describedby="emailHelp"
                            placeholder="Enter email"
                            required=""
                          />
                          <button
                            type="button"
                            class="btn btn-primary"
                            style="margin: 10px 1px; display: block; border-radius: 10px;background:#6773DD;"
                          >
                            Verify
                          </button>
                        </div>
                        <div
                          class="form-group"
                        >
                          <label for="exampleInputEmail1">Company Phone Number*</label>
                          <div
                            style="
                              flex: 1 1 0%;
                              flex-direction: row;
                              justify-content: space-between;
                              display: flex;
                              border: 1px solid #c8cccf;
                              border-radius: 10px;
                            "
                          >
                            <vue-country-code
                              @onSelect="onSelect"
                              :preferredCountries="['lk', 'us', 'gb']"
                              style="border: 0"
                            >
                            </vue-country-code>
                            <input
                              class="form-control"
                              id="exampleInputEmail1"
                              aria-describedby="emailHelp"
                              placeholder="Enter mobile number"
                              required=""
                              type="tel"
                              style="max-width: 90%; border: 0"
                            />
                          </div>
                          <button
                            type="button"
                            class="btn btn-primary"
                            style="margin: 10px 1px; display: block;border-radius: 10px;background:#6773DD;"
                          >
                            Verify
                          </button>
                        </div>
                        <div class="form-group">
                          <label for="exampleInputClientAddressLine"
                            >Address Line 1*</label
                          >
                          <input
                            type="text"
                            class="form-control"
                            id="exampleInputClientAddressLine"
                            placeholder="Enter Address Line 1"
                            required=""
                          />
                        </div>
                        <div class="form-group">
                          <label for="exampleInputClientAddressLine2"
                            >Address Line 2</label
                          >
                          <input
                            type="text"
                            class="form-control"
                            id="exampleInputClientAddressLine2"
                            placeholder="Enter Address Line 2"
                            required=""
                          />
                        </div>
                        <div class="form-group">
                          <label for="exampleInputClientAddressState"
                            >State / Province</label
                          >
                          <input
                            type="text"
                            class="form-control"
                            id="exampleInputState"
                            placeholder="Enter State / Province"
                            required=""
                          />
                        </div>
                        <div class="form-group">
                          <label for="exampleInputClientAddressPostal"
                            >Postal / Zip Code</label
                          >
                          <input
                            type="text"
                            class="form-control"
                            id="exampleInputClientAddressPostal"
                            placeholder="Enter Postal / Zip Code"
                            required=""
                          />
                        </div>
                        <div class="form-group">
                          <label for="exampleInputClientAddresCity">City</label>
                          <input
                            type="text"
                            class="form-control"
                            id="exampleInputClientAddresCity"
                            placeholder="Enter City"
                            required=""
                          />
                        </div>
                        <div class="form-group">
                          <label for="exampleInputClientAddresCountry"
                            >Country</label
                          >
                          <div
                            style="
                              flex: 1 1 0%;
                              flex-direction: row;
                              justify-content: space-between;
                              display: flex;
                              border: 1px solid #c8cccf;
                              border-radius: 10px;
                            "
                          >
                            <vue-country-code
                              @onSelect="onSelectCountry"
                              :preferredCountries="['lk', 'us', 'gb']"
                              style="border: 0"
                            >
                            </vue-country-code>
                            <input
                              class="form-control"
                              id="exampleInputClientAddresCountry"
                              aria-describedby="emailHelp"
                              placeholder="Enter Country"
                              required=""
                              type="text"
                              readonly
                              style="max-width: 90%; border: 0"
                              v-model="country"
                            />
                          </div>
                        </div>
                        <div
                          class="form-group"
                        >
                          <label for="exampleInputNIC"
                            >Company Registration*<span class="tooltip" style="display: contents;">
                            <span class="tooltiptext"></span>
                            <span class="fa fa-question-circle"></span>
                          </span></label
                          >
                          <div v-bind:key="index" v-for="(item, index) in clientRepresenterInputNIC" style="display: block; margin: 10px 0; position: relative;">
                            <input
                              type="file"
                              class="form-control"
                              v-on:change="onChangeClientRepresenterInputNICDocs($event, index)"
                              name="inputNIC"
                              id="exampleInputNIC"
                              accept=".jpg,.png"
                              required=""
                            />
                            <button
                              type="button"
                              v-if="(clientRepresenterInputNIC.length - 1) == index && (clientRepresenterInputNIC.length) !== clientRepresenterInputNICLimit"
                              style="position: absolute; top: calc((100% - 25px) / 2); right: -30px; height: 25px;"
                              v-on:click="onAddClientRepresenterInputNIC"
                            >
                              +
                            </button>
                          </div>
                        </div>
                        <div
                          class="form-group"
                          style="position: relative;"
                        >
                          <label for="exampleInputLegal"
                            >Company Approval Letter*<span class="tooltip" style="display: contents;">
                            <span class="tooltiptext"></span>
                            <span class="fa fa-question-circle"></span>
                          </span></label
                          >
                          <div v-bind:key="index" v-for="(item, index) in clientInputLegalDocs" style="display: block; margin: 10px 0; position: relative;">
                            <input
                              type="file"
                              class="form-control"
                              v-on:change="onChangeClientInputLegalDocs($event, index)"
                              name="inputLegal"
                              id="exampleInputLegal"
                              accept=".jpg,.png"
                              required=""
                            />
                            <button
                              type="button"
                              v-if="(clientInputLegalDocs.length - 1) == index && (clientInputLegalDocs.length) !== clientInputLegalDocsLimit"
                              style="position: absolute; top: calc((100% - 25px) / 2); right: -30px; height: 25px;"
                              v-on:click="onAddClientInputLegalDocs"
                            >
                              +
                            </button>
                          </div>
                        </div>
                        <div
                          class="form-group"
                        >
                          <label for="exampleInputSignature">Billing Proof*<span class="tooltip" style="display: contents;">
                            <span class="tooltiptext"></span>
                            <span class="fa fa-question-circle"></span>
                          </span></label>
                          <div v-bind:key="index" v-for="(item, index) in clientInputSignature" style="display: block; margin: 10px 0; position: relative;">
                            <input
                              type="file"
                              class="form-control"
                              v-on:change="onChangeClientInputSignatureDocs($event, index)"
                              name="inputSignature"
                              id="exampleInputSignature"
                              accept=".jpg,.png"
                              required=""
                            />
                            <button
                              type="button"
                              v-if="(clientInputSignature.length - 1) == index && (clientInputSignature.length) !== clientInputSignatureLimit"
                              style="position: absolute; top: calc((100% - 25px) / 2); right: -30px; height: 25px;"
                              v-on:click="onAddClientInputSignature"
                            >
                              +
                            </button>
                          </div>
                        </div>
                        <div class="form-group">
                          <label for="exampleInputBirthCert"
                            >Supporting Documents*<span class="tooltip" style="display: contents;">
                            <span class="tooltiptext"></span>
                            <span class="fa fa-question-circle"></span>
                          </span></label
                          >
                          <div v-bind:key="index" v-for="(item, index) in clientSupportingInputSignature" style="display: block; margin: 10px 0; position: relative;">
                            <input
                              type="file"
                              class="form-control"
                              v-on:change="onChangeClientSupportingInputSignatureDocs($event, index)"
                              name="inputSignature"
                              id="exampleInputSignature"
                              accept=".jpg,.png"
                              required=""
                            />
                            <button
                              type="button"
                              v-if="(clientSupportingInputSignature.length - 1) == index && (clientSupportingInputSignature.length) !== clientSupportingInputSignatureLimit"
                              style="position: absolute; top: calc((100% - 25px) / 2); right: -30px; height: 25px;"
                              v-on:click="onAddClientSupportingInputSignature"
                            >
                              +
                            </button>
                          </div>
                        </div>
                      </div>
                      <h3 v-if="businessType === 'Celebrity' && userType !== 'MySelf'" style="margin-bottom: 20px;">Client Details</h3>
                      <div v-if="businessType === 'Celebrity' && userType !== 'MySelf'">
                        <div class="form-group">
                          <label for="exampleInputEmail1">Full Name*</label>
                          <input
                            type="text"
                            class="form-control"
                            id=""
                            aria-describedby=""
                            placeholder="Enter Full Name"
                            required=""
                          />
                        </div>
                        <div class="form-group">
                          <label for="exampleInputEmail1">Date of Birth*</label>
                          <datetime
                            v-model="dateOfBirth"
                            type="date"
                            input-style="width: 100%;"
                            required=""
                          ></datetime>
                        </div>
                        <div class="form-group">
                          <label for="exampleInputEmail1">Gender*</label>
                          <span
                            class="wpcf7-form-control-wrap select-options"
                            style="display: block; width: 100%"
                            ><select
                              v-model="gender"
                              name="gender"
                              class="wpcf7-form-control wpcf7-select wpcf7-validates-as-required"
                              aria-required="true"
                              aria-invalid="false"
                              required=""
                              style="background: white; width: 100%"
                            >
                              <option value="N/A">N/A</option>
                              <option value="Male">Male</option>
                              <option value="Female">Female</option>
                            </select></span
                          >
                        </div>
                        <div
                          class="form-group"
                          v-if="userType == 'Representer'"
                        >
                          <label for="exampleInputEmail1">Email address*</label>
                          <input
                            type="email"
                            class="form-control"
                            id="exampleInputEmail1"
                            aria-describedby="emailHelp"
                            placeholder="Enter email"
                            required=""
                          />
                          <button
                            type="button"
                            class="btn btn-primary"
                            style="margin: 10px 1px; display: block;border-radius: 10px;background:#6773DD;"
                          >
                            Verify
                          </button>
                        </div>
                        <div
                          class="form-group"
                          v-if="userType == 'Representer'"
                        >
                          <label for="exampleInputEmail1">Mobile Number*</label>
                          <div
                            style="
                              flex: 1 1 0%;
                              flex-direction: row;
                              justify-content: space-between;
                              display: flex;
                              border: 1px solid #c8cccf;
                              border-radius: 10px;
                            "
                          >
                            <vue-country-code
                              @onSelect="onSelect"
                              :preferredCountries="['lk', 'us', 'gb']"
                              style="border: 0"
                            >
                            </vue-country-code>
                            <input
                              class="form-control"
                              id="exampleInputEmail1"
                              aria-describedby="emailHelp"
                              placeholder="Enter mobile number"
                              required=""
                              type="tel"
                              style="max-width: 90%; border: 0"
                            />
                          </div>
                          <button
                            type="button"
                            class="btn btn-primary"
                            style="margin: 10px 1px; display: block;border-radius: 10px;background:#6773DD;"
                          >
                            Verify
                          </button>
                        </div>
                        <div class="form-group">
                          <label for="exampleInputClientAddressLine"
                            >Address Line 1*</label
                          >
                          <input
                            type="text"
                            class="form-control"
                            id="exampleInputClientAddressLine"
                            placeholder="Enter Address Line 1"
                            required=""
                          />
                        </div>
                        <div class="form-group">
                          <label for="exampleInputClientAddressLine2"
                            >Address Line 2</label
                          >
                          <input
                            type="text"
                            class="form-control"
                            id="exampleInputClientAddressLine2"
                            placeholder="Enter Address Line 2"
                            required=""
                          />
                        </div>
                        <div class="form-group">
                          <label for="exampleInputClientAddressState"
                            >State/Province</label
                          >
                          <input
                            type="text"
                            class="form-control"
                            id="exampleInputState"
                            placeholder="Enter State / Province"
                            required=""
                          />
                        </div>
                        <div class="form-group">
                          <label for="exampleInputClientAddressPostal"
                            >Postal / Zip Code</label
                          >
                          <input
                            type="text"
                            class="form-control"
                            id="exampleInputClientAddressPostal"
                            placeholder="Enter Postal / Zip Code"
                            required=""
                          />
                        </div>
                        <div class="form-group">
                          <label for="exampleInputClientAddresCity">City</label>
                          <input
                            type="text"
                            class="form-control"
                            id="exampleInputClientAddresCity"
                            placeholder="Enter City"
                            required=""
                          />
                        </div>
                        <div class="form-group">
                          <label for="exampleInputClientAddresCountry"
                            >Country</label
                          >
                          <div
                            style="
                              flex: 1 1 0%;
                              flex-direction: row;
                              justify-content: space-between;
                              display: flex;
                              border: 1px solid #c8cccf;
                              border-radius: 10px;
                            "
                          >
                            <vue-country-code
                              @onSelect="onSelectCountry"
                              :preferredCountries="['lk', 'us', 'gb']"
                              style="border: 0"
                            >
                            </vue-country-code>
                            <input
                              class="form-control"
                              id="exampleInputClientAddresCountry"
                              aria-describedby="emailHelp"
                              placeholder="Enter Country"
                              required=""
                              type="text"
                              readonly
                              style="max-width: 90%; border: 0"
                              v-model="country"
                            />
                          </div>
                        </div>
                        <div
                          class="form-group"
                          v-if="userType == 'Representer'"
                        >
                          <label for="exampleInputNIC"
                            >National Identity Card or Passport*<span class="tooltip" style="display: contents;">
                            <span class="tooltiptext"></span>
                            <span class="fa fa-question-circle"></span>
                          </span></label
                          >
                          <div v-bind:key="index" v-for="(item, index) in clientRepresenterInputNIC" style="display: block; margin: 10px 0; position: relative;">
                            <input
                              type="file"
                              class="form-control"
                              v-on:change="onChangeClientRepresenterInputNICDocs($event, index)"
                              name="inputNIC"
                              id="exampleInputNIC"
                              accept=".jpg,.png"
                              required=""
                            />
                            <button
                              type="button"
                              v-if="(clientRepresenterInputNIC.length - 1) == index && (clientRepresenterInputNIC.length) !== clientRepresenterInputNICLimit"
                              style="position: absolute; top: calc((100% - 25px) / 2); right: -30px; height: 25px;"
                              v-on:click="onAddClientRepresenterInputNIC"
                            >
                              +
                            </button>
                          </div>
                          <!-- <input
                            type="file"
                            class="form-control"
                            name="exampleInputNICFront"
                            id="exampleInputNIC"
                            accept=".jpg,.png"
                            required=""
                          />
                          <input
                            type="file"
                            class="form-control"
                            name="exampleInputNIC"
                            id="exampleInputNICBack"
                            accept=".jpg,.png"
                            required=""
                          /> -->
                        </div>
                        <div
                          class="form-group"
                          v-if="userType == 'Representer'"
                          style="position: relative;"
                        >
                          <label for="exampleInputLegal"
                            >Billing Proof*<span class="tooltip" style="display: contents;">
                            <span class="tooltiptext"></span>
                            <span class="fa fa-question-circle"></span>
                          </span></label
                          >
                          <div v-bind:key="index" v-for="(item, index) in clientInputLegalDocs" style="display: block; margin: 10px 0; position: relative;">
                            <input
                              type="file"
                              class="form-control"
                              v-on:change="onChangeClientInputLegalDocs($event, index)"
                              name="inputLegal"
                              id="exampleInputLegal"
                              accept=".jpg,.png"
                              required=""
                            />
                            <button
                              type="button"
                              v-if="(clientInputLegalDocs.length - 1) == index && (clientInputLegalDocs.length) !== clientInputLegalDocsLimit"
                              style="position: absolute; top: calc((100% - 25px) / 2); right: -30px; height: 25px;"
                              v-on:click="onAddClientInputLegalDocs"
                            >
                              +
                            </button>
                          </div>
                        </div>
                        <div class="form-group" v-if="userType == 'Guardian'">
                          <label for="exampleInputBirthCert"
                            >Billing Proof*<span class="tooltip" style="display: contents;">
                            <span class="tooltiptext"></span>
                            <span class="fa fa-question-circle"></span>
                          </span></label
                          >
                          <div v-bind:key="index" v-for="(item, index) in clientSupportingInputBillProof" style="display: block; margin: 10px 0; position: relative;">
                            <input
                              type="file"
                              class="form-control"
                              v-on:change="onChangeClientSupportingInputillProofDocs($event, index)"
                              name="inputSignature"
                              id="exampleInputSignature"
                              accept=".jpg,.png"
                              required=""
                            />
                            <button
                              type="button"
                              v-if="(clientSupportingInputBillProof.length - 1) == index && (clientSupportingInputBillProof.length) !== clientSupportingInputBillProofLimit"
                              style="position: absolute; top: calc((100% - 25px) / 2); right: -30px; height: 25px;"
                              v-on:click="onAddClientSupportingInputBillProof"
                            >
                              +
                            </button>
                          </div>
                        </div>
                        <div class="form-group" v-if="userType == 'Guardian'">
                          <label for="exampleInputBirthCert"
                            >Birth Certificate*<span class="tooltip" style="display: contents;">
                            <span class="tooltiptext"></span>
                            <span class="fa fa-question-circle"></span>
                          </span></label
                          >
                          <input
                            type="file"
                            class="form-control"
                            id="exampleInputBirthCert"
                            accept=".jpg,.png"
                            required=""
                          />
                        </div>
                        <div class="form-group">
                          <label for="exampleInputLegalDocs"
                            >Supporting Documents*<span class="tooltip" style="display: contents;">
                            <span class="tooltiptext"></span>
                            <span class="fa fa-question-circle"></span>
                          </span></label
                          >
                          <div v-bind:key="index" v-for="(item, index) in clientSupportingInputSignature" style="display: block; margin: 10px 0; position: relative;">
                            <input
                              type="file"
                              class="form-control"
                              v-on:change="onChangeClientSupportingInputSignatureDocs($event, index)"
                              name="inputSignature"
                              id="exampleInputSignature"
                              accept=".jpg,.png"
                              required=""
                            />
                            <button
                              type="button"
                              v-if="(clientSupportingInputSignature.length - 1) == index && (clientSupportingInputSignature.length) !== clientSupportingInputSignatureLimit"
                              style="position: absolute; top: calc((100% - 25px) / 2); right: -30px; height: 25px;"
                              v-on:click="onAddClientSupportingInputSignature"
                            >
                              +
                            </button>
                          </div>
                        </div>
                        <div
                          class="form-group"
                          v-if="userType == 'Representer'"
                        >
                          <label for="exampleInputSignature">Signature*<span class="tooltip" style="display: contents;">
                            <span class="tooltiptext"></span>
                            <span class="fa fa-question-circle"></span>
                          </span></label>
                          <div v-bind:key="index" v-for="(item, index) in clientInputSignature" style="display: block; margin: 10px 0; position: relative;">
                            <input
                              type="file"
                              class="form-control"
                              v-on:change="onChangeClientInputSignatureDocs($event, index)"
                              name="inputSignature"
                              id="exampleInputSignature"
                              accept=".jpg,.png"
                              required=""
                            />
                            <button
                              type="button"
                              v-if="(clientInputSignature.length - 1) == index && (clientInputSignature.length) !== clientInputSignatureLimit"
                              style="position: absolute; top: calc((100% - 25px) / 2); right: -30px; height: 25px;"
                              v-on:click="onAddClientInputSignature"
                            >
                              +
                            </button>
                          </div>
                        </div>
                      </div>
                      <button type="button" class="btn btn-primary check-btn" v-on:click="goNext" style="border-radius: 10px;background:#6773DD;display:block;margin: 0 auto;">
                        Next
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            <div class="clearfix"></div>
          </div>
          <!-- .entry-content -->
        </article>
      </main>
    </div>
  </div>
</template>

<script>
import { Datetime } from "vue-datetime";

export default {
  name: "support_track",
  data() {
    return {
      msg: "Clear Me Out - Support",
      userType: "MySelf",
      businessType: "Business",
      ticketNumber: "",
      emailRequiredError: false,
      ticketNumberRequiredError: false,
      emailError: false,
      dateOfBirth: new Date(),
      country: "Sri Lanka",
      clientInputLegalDocsLimit: 2,
      clientInputSignatureLimit: 2,
      clientSupportingInputSignatureLimit: 2,
      clientInputNICLimit: 2,
      clientInputBillingProofLimit: 2,
      clientInputPermissionLetterLimit: 2,
      clientRepresenterInputNICLimit: 2,
      clientInputSignLimit: 1,
      clientInputSupportingDocsLimit: 2,
      clientSupportingInputBillProofLimit: 2,
      gender: "",
      clientInputLegalDocs: [{file: ""}],
      clientInputSignature: [{file: ""}],
      clientSupportingInputSignature: [{file: ""}],
      clientSupportingInputBillProof: [{file: ""}],
      clientInputNIC: [{file: ""}],
      clientInputBillingProof: [{file: ""}],
      clientInputPermissionLetter: [{file: ""}],
      clientInputSupportingDocs: [{file: ""}],
      clientInputSign: [{file: ""}],
      clientRepresenterInputNIC: [{file: ""}],
      viewUserPassword: false,
      userPasswordType: "password",
    };
  },
  components: {
    datetime: Datetime,
  },
  methods: {
    showPassword: function() {
      this.viewUserPassword = true;
      this.userPasswordType = "text";
    },
    hidePassword: function() {
      this.viewUserPassword = false;
      this.userPasswordType = "password";
    },
    onSelect: function (d) {
      console.log("e", d);
    },
    goNext: function (d) {
      this.$store.commit({
        type: "selectedPackage",
        form_businessType: this.businessType,
        form_userType: this.userType,
      });
      this.$router.push("select-package");
    },
    onAddClientInputLegalDocs: function (d) {
      if(this.clientInputLegalDocs.length > this.clientInputLegalDocsLimit) {
        return;
      }
      this.clientInputLegalDocs.push({file: ""});
    },
    onAddClientInputSignature: function (d) {
      if(this.clientInputSignature.length > this.clientInputSignatureLimit) {
        return;
      }
      this.clientInputSignature.push({file: ""});
    },
    onAddClientSupportingInputSignature: function (d) {
      if(this.clientSupportingInputSignature.length > this.clientSupportingInputSignatureLimit) {
        return;
      }
      this.clientSupportingInputSignature.push({file: ""});
    },
    onAddClientSupportingInputBillProof: function (d) {
      if(this.clientSupportingInputBillProof.length > this.clientSupportingInputBillProofLimit) {
        return;
      }
      this.clientSupportingInputBillProof.push({file: ""});
    },
    onAddClientInputNIC: function (d) {
      if(this.clientInputNIC.length > this.clientInputNICLimit) {
        return;
      }
      this.clientInputNIC.push({file: ""});
    },
    onAddClientInputBillingProof: function (d) {
      if(this.clientInputBillingProof.length > this.clientInputBillingProofLimit) {
        return;
      }
      this.clientInputBillingProof.push({file: ""});
    },
    onAddClientInputPermissionLetter: function (d) {
      if(this.clientInputPermissionLetter.length > this.clientInputPermissionLetterLimit) {
        return;
      }
      this.clientInputPermissionLetter.push({file: ""});
    },
    onAddClientInputSupportingDocs: function (d) {
      if(this.clientInputSupportingDocs.length > this.clientInputSupportingDocsLimit) {
        return;
      }
      this.clientInputSupportingDocs.push({file: ""});
    },
    onAddClientInputSign: function (d) {
      if(this.clientInputSign.length > this.clientInputSignLimit) {
        return;
      }
      this.clientInputSign.push({file: ""});
    },
    onAddClientRepresenterInputNIC: function (d) {
      if(this.clientRepresenterInputNIC.length > this.clientRepresenterInputNICLimit) {
        return;
      }
      this.clientRepresenterInputNIC.push({file: ""});
    },
    onChangeClientInputLegalDocs: function (item, index) {
      if(item && item.target && item.target.files && Array.isArray(item.target.files)) {
        this.clientInputLegalDocs[index].file = item.target.files[0];
      } else {
        this.clientInputLegalDocs[index].file = null;
      }
    },
    onChangeClientInputSignatureDocs: function (item, index) {
      if(item && item.target && item.target.files && Array.isArray(item.target.files)) {
        this.clientInputSignature[index].file = item.target.files[0];
      } else {
        this.clientInputSignature[index].file = null;
      }
    },
    onChangeClientSupportingInputSignatureDocs: function (item, index) {
      if(item && item.target && item.target.files && Array.isArray(item.target.files)) {
        this.clientSupportingInputSignature[index].file = item.target.files[0];
      } else {
        this.clientSupportingInputSignature[index].file = null;
      }
    },
    onSelectCountry: function (d) {
      console.log("onSelectCountry:e", d);
      this.country = d.name;
    },
    submit: function (e) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      const $this = this;
      this.emailRequiredError = false;
      this.ticketNumberRequiredError = false;
      this.emailError = false;

      jQuery
        .post("http://stagingportal.clearmeout.com/signup.php")
        .done(function (data) {
          console.log("data", data);
          $this.email = "";
          $this.ticketNumber = "";
          if (data.status == 500) {
            $this.$toast.open({
              message: data.status_message,
              type: "error",
            });
          }
        })
        .fail(function (data) {
          console.log("data", data);
          $this.$toast.open({
            message:
              "Invalid registration details. Please update and submit again.",
            type: "error",
          });
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.video-container {
  display: block;
  min-height: 40vw;
}
.bg-1,
.bg-2 {
  display: block;
  width: 100%;
  height: calc(40vw / 2);
}

.bg-1 {
  background: #fff;
}

.bg-2 {
  background: #6b67e4;
}
.vimeo-container {
  position: relative;
  min-height: 500px;
  overflow: hidden;
  padding: 0;
}
.vimeo-wrapper-test {
  display: block;
  position: absolute;
  top: 0%;
  left: calc((100vw - 50vw) / 2);
  margin: 0 auto;
  width: calc(50vw);
  height: 100%;
}
.vimeo-wrapper-test iframe {
  width: 100%;
  height: 100%; /* Given a 16:9 aspect ratio, 9/16*100 = 56.25 */
  min-height: 100%;
  /* min-width: 177.77vh; Given a 16:9 aspect ratio, 16/9*100 = 177.77 */
  position: relative;
  top: 0%;
  left: 0%;
  /* transform: translate(-50%, -50%); */
}

.tooltip {
  position: relative;
  /* display: inline-block; */
  border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 10px;
  font-size: 0.8em;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  bottom: 100%;
  left: 0;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/register.vue